import { render } from "./MarginTypeModal.vue?vue&type=template&id=45403682"
import script from "./MarginTypeModal.vue?vue&type=script&lang=js"
export * from "./MarginTypeModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__